
export const Skillsdata = ['Data Science','JavaScript','React Native', 'Typescript', 'React', 'Next.js','Next 15', 'UI/UX', 'FLask', 'Machine Learning', 'R','Data Managment','Python','Programming','Tableau','AI'];
    
    
